import React, { useState } from "react";
import { UploadZone, DownloadButton, ResetButton, loadImage } from "./_shared";
import { FlipHorizontal2, FlipVertical2 } from "lucide-react";

export default function FlipImage() {
  const [file, setFile] = useState(null);
  const [outUrl, setOutUrl] = useState(null);

  const flip = async (f, horizontal) => {
    const { img } = await loadImage(f);
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth; canvas.height = img.naturalHeight;
    const ctx = canvas.getContext("2d");
    if (horizontal) { ctx.translate(canvas.width, 0); ctx.scale(-1, 1); }
    else { ctx.translate(0, canvas.height); ctx.scale(1, -1); }
    ctx.drawImage(img, 0, 0);
    canvas.toBlob((blob) => {
      if (outUrl) URL.revokeObjectURL(outUrl);
      setOutUrl(URL.createObjectURL(blob));
    }, "image/png", 0.95);
  };

  const handleFile = async (f) => { setFile(f); await flip(f, true); };
  const reset = () => { setFile(null); setOutUrl(null); };

  if (!file) return <UploadZone onFile={handleFile} />;
  return (
    <div className="space-y-6">
      <div className="rounded-2xl border border-slate-200 dark:border-white/10 overflow-hidden bg-slate-50 dark:bg-[#0b0c0e] p-4">
        {outUrl && <img src={outUrl} alt="flipped" className="w-full max-h-96 object-contain" />}
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <button onClick={() => flip(file, true)} data-testid="flip-horizontal" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-200 text-sm hover:bg-slate-50 dark:hover:bg-white/5"><FlipHorizontal2 size={14} /> Horizontal</button>
        <button onClick={() => flip(file, false)} data-testid="flip-vertical" className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg border border-slate-200 dark:border-white/10 text-slate-700 dark:text-slate-200 text-sm hover:bg-slate-50 dark:hover:bg-white/5"><FlipVertical2 size={14} /> Vertical</button>
        <DownloadButton href={outUrl} filename={`flipped-${file.name}`}>Download</DownloadButton>
        <ResetButton onClick={reset} />
      </div>
    </div>
  );
}
